import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    Title,
    CategoryScale,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(LineElement, PointElement, LinearScale, Title, CategoryScale);

export const chartOptions = {
    width: 100,
    height: 30,
    options: {
        scale: {
            grid: { color: "rgb(255, 99, 132)" },
        },
        responsive: true,
        scales: {
            y: {
                ticks: {
                    display: true,
                    stepSize: 1,
                },
            },
        },
        borderColor: "rgb(255, 99, 132)",
        backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
};

const LineGraph = ({ data }) => (
    <Line
        width={100}
        height={30}
        options={{
            responsive: true,
            scales: {
                y: {
                    ticks: {
                        stepSize: 1,
                    },
                    min: 0,
                },
            },
            borderColor: "rgb(255, 99, 132)",
            backgroundColor: "rgba(255, 99, 132, 0.5)",
        }}
        data={data}
    />
);

export default LineGraph;
